<style lang="less">
.om-audio {
  position: absolute;
  top: -9999px;
  left: -9999px;
  width: 100px;
}
.inEnvDev {
  .om-audio {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
  }
}
</style>
<template>
  <div class="om-audio">
    <k-audio
      :src="src"
      :toggle="playSwitch"
      @timeupdate="timeupdate"
      @playing="playing"
      @pause="pause"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'om-audio',
  computed: {
    ...mapGetters(['inEnvDev']),
    ...mapGetters('oneminute', ['curItem', 'playSwitch']),
    src() {
      const { curItem } = this
      return curItem && curItem.url ? curItem.url : ''
      // return curItem ? curItem.url : "https://staticcdn-yy-prd.pydp888.com/data/mp3/none.mp3";
      // return curItem ? curItem.url : "data:audio/mp3;base64,SUQzBAAAAAAANFRDT04AAAAHAAADT3RoZXIAVFNTRQAAAA8AAANMYXZmNTguMjYuMTAxAAAAAAAAAAAAAAD/4zjAAAAAAAAAAAAASW5mbwAAAA8AAAAJAAADYABVVVVVVVVVVVVVVWpqampqampqampqgICAgICAgICAgICVlZWVlZWVlZWVlaqqqqqqqqqqqqqqwMDAwMDAwMDAwMDV1dXV1dXV1dXV1erq6urq6urq6urq//////////////8AAAAATGF2YzU4LjQ3AAAAAAAAAAAAAAAAJAJgAAAAAAAAA2Cj84zBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/4xjEAAr4Bd3oAEQAgSQDFT0zzD8ya5h+ad0mcya0G/1hw2crIGTMyYNf/NO6TMsZNPmjf/6DP9BYEJgMBhF4WdLiAP8oiUP/4xjEDwuIBkAAAMQAhCXwBbV6nSgnU7CBlygG1RNq+sz338nTlGqXfT/0y9WACEw1qhIXMpqOUMschL7FW/uZt9Hb0Mo1ru3/4xjEGwnoAlFwCIYAOaWz9pB/o/Z/u/uvWoCrNoJBd14KiljFHK+/V7vd3Y7PN/jP+x//9ScY3t//p01VxCajbcck0ZkX3a7/4xjELgiYAlTQCMYAq1Cxe6/r0XVv/p+n+3b/4v/c/7e32fWqgYaY8yptiQ8VbUH4F1+dPb//p51NelP6Edv65ej7v2f/8wj/4xjERgiIAmpYCEYAQ9aqQBKAjlYIPDwDQ4CveAzj3uaL1LXQ8In6P0byVn/6ZOj//p2bDX/7EfTVgQJOd7zNrxzivrpp9dX/4xjEXglgAlTwCEYA0M/V81/b9Xq/2+hVyPr//zSYqkNaX7+uJa1jH69GVJSrolO/edJcr+qp+vquLB31fzyw7K//X0/leWr/4xjEcwpIQkQAAMQATEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqr/4xjEhAgoBlmQAEYAqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqr/4xjEngngAj2QCMYAqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqo=";
    },
    oid() {
      const { curItem } = this
      return curItem && curItem.oid > 0 ? +curItem.oid : 0
    }
  },
  methods: {
    ...mapMutations('oneminute', ['playUpdate']),
    update(data) {
      const { oid } = this
      if (oid > 0) {
        this.playUpdate({ ...data, oid })
      }
    },
    playing(e) {
      // console.log(e)
      this.update({ playing: true, duration: e.duration })
    },
    pause() {
      this.update({ playing: false })
    },
    timeupdate(e) {
      this.update({ time: e.time })
    }
  }
}
</script>
